import { emptyErrorResponse } from '@/constant';
import store from '@redux/store/store';
import { isArrayNotEmpty } from '@/util';
import { AxiosError } from 'axios';
import { snackbarActions } from '@/redux';
import { AlertColor } from '@mui/material/Alert/Alert';
import { ErrorResponse } from '@/model';
import { t } from '@localization/i18n';

export const handleErrorResponse = async (error) => {
  if (error.response && error.response.status === 404) {
    return await response404(error);
  }
  if (error.response && error.response.status === 422) {
    return await response422(error);
  }
  if (error.response && error.response.status === 500) {
    return await response500(error);
  }

  const { response } = error;
  if (response) {
    switch (response.status) {
      case 401:
        return handle401Response(error);
    }
  }

  return Promise.reject(error);
};

function capitalizeFirstLetter(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

export const response500 = async (error) => {
  const errorResponse = error.response.data;
  var res = [];
  errorResponse.fieldErrors.map((e) =>
    res.push(capitalizeFirstLetter(e.fieldName) + ': ' + e.errorMsg),
  );
  errorResponse.logicalErrors.map((e) => res.push(e.errorMsg));
  return {
    error: res,
    status: 500,
  };
};

export const response422 = async (error: AxiosError) => {
  const errorResponse = error.response.data as ErrorResponse;

  const logicalErrors = errorResponse.logicalErrors;
  const fieldErrors = errorResponse.fieldErrors;

  const snackBarMessage = [
    isArrayNotEmpty(logicalErrors) ? t('error.logical_errors') : null,
    isArrayNotEmpty(fieldErrors) ? t('error.field_errors') : null,
  ]
    .filter(Boolean)
    .join(', ');

  const logicalErrorMessage = isArrayNotEmpty(logicalErrors)
    ? `${t('error.logical_errors')}: \n\n${logicalErrors.map(({ errorMsg }) => `- ${errorMsg}`).join('\n')}`
    : null;

  const fieldErrorMessage = isArrayNotEmpty(fieldErrors)
    ? `${t('error.field_errors')}: \n\n${fieldErrors
        .map(({ fieldName, errorMsg }) => `- ${fieldName}:${errorMsg}`)
        .join('\n')}`
    : null;

  const detailErrorMessage = [logicalErrorMessage, fieldErrorMessage]
    .filter(Boolean)
    .join('\n\n');

  dispatchSnackbar(snackBarMessage, 'error', detailErrorMessage);

  return emptyErrorResponse;
};

export const handle401Response = async (error) => {};

export const response404 = async (error) => {
  const errorResponse = error.response.data.message;
  return {
    error: [errorResponse],
    status: 404,
  };
};

const dispatchSnackbar = (
  message: string,
  severity: AlertColor,
  detailedMessage?: string,
) =>
  store.dispatch(
    snackbarActions.openSnackbar({
      message,
      severity,
      detailedMessage,
    }),
  );
